import { N as NON_FOLLOWED_TAG, i as PRODUCT_BULKY_TAG, j as NEW_RELEASE_TAG, k as INNOVATION_TAG, t as translate } from './built-constants-439d5572.js';
import { P as PRODUCT_PAGE_COPY } from './built-price-format-dc3d77ee.js';

/**
 * @todo Make `MIN_QUANTITY_THRESHOLD` threshold dynamic based on theme settings
 */

const MIN_QUANTITY_THRESHOLD = 5;
/**
 * Helper to determine if a given variant has quantity above the minimum threshold
 * @param {Variant} variant
 * @returns {boolean}
 */

const variantHasSufficientQuantity = variant => variant.inventory_quantity >= MIN_QUANTITY_THRESHOLD;
/**
 * A custom type with cherry-picked properties from the `ProductJSON` type
 * @typedef {Pick<import('../../product-json').ProductJSON, 'tags'> } ProductWithTagsOnly
 */

/**
 * Helper to determine if a product is an "End Of Life" product
 * @see https://app.gitbook.com/@decathlonusa/s/shopify/product-feature/product-page#sold-out-logic
 * @todo Similar code exists in scripts/cart/cart.js, add a generic
 * hasTag(tag, product) and extra helpers like this for isBulky, etc.
 *
 * @param {ProductWithTagsOnly} product
 * @returns {boolean}
 */

const isNonFollowedProduct = product => product == null ? void 0 : product.tags.includes(NON_FOLLOWED_TAG);
/**
 * @param {ProductWithTagsOnly} product
 * @returns {boolean}
 */

const isBulkyProduct = product => product == null ? void 0 : product.tags.includes(PRODUCT_BULKY_TAG);
/**
 * @param {ProductWithTagsOnly} product
 * @returns {boolean}
 */

const isNewReleaseProduct = product => product == null ? void 0 : product.tags.includes(NEW_RELEASE_TAG);
/**
 * @param {ProductWithTagsOnly} product
 * @returns {boolean}
 */

const isInnovationProduct = product => product == null ? void 0 : product.tags.includes(INNOVATION_TAG);

/**
 * Shopify error scenario 1:
 * "If the product is entirely sold out"
 *
 * Shopify error `description` value:
 * `The product #{item.name} is already sold out.`
 *
 * @see https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#error-responses
 */
const ERROR_SCENARIO_1_REGEX = /.*the\sproduct.*is\salready\ssold\sout\.$/i;
/**
 * Shopify error scenario 2:
 * "If the product is not sold out but the requested quantity exceeds
 * what is available, yet at least 1 item can still be added to the cart"
 *
 * Shopify error `description` value:
 * `You can only add #{item.remaining_inventory} #{item.name} to the cart.`
 *
 * @see https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#error-responses
 */

const ERROR_SCENARIO_2_REGEX = /.*you\scan\sonly\sadd.*to\sthe\scart\.$/i;
/**
 * Shopify error scenario 3:
 * "If the product is not sold out, but all of its stock is in the cart"
 *
 * Shopify error `description` value:
 * `All #{item.inventory_quantity} #{item.name} are in your cart.`
 *
 * @see https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#error-responses
 */

const ERROR_SCENARIO_3_REGEX = /.*all.*are\sin\syour\scart\.$/i;
/**
 * Determines if the `description` maps to Shopify error scenario 1
 *
 * @param {string} message A Shopify `description` value
 * @returns {boolean}
 */

const isErrorScenario1 = message => ERROR_SCENARIO_1_REGEX.test(message);
/**
 * Determines if the `description` maps to Shopify error scenario 2
 *
 * @param {string} message A Shopify `description` value
 * @returns {boolean}
 */

const isErrorScenario2 = message => ERROR_SCENARIO_2_REGEX.test(message);
/**
 * Determines if the `description` maps to Shopify error scenario 3
 *
 * @param {string} message A Shopify `description` value
 * @returns {boolean}
 */

const isErrorScenario3 = message => ERROR_SCENARIO_3_REGEX.test(message);
/**
 * Gets the first digit in the given message
 * @param {string} message A Shopify error `description` value
 * @returns {string}
 */

const getQuantityFromMessage = message => (message == null ? void 0 : message.split(/\s/g).find(word => /\d/g.test(word))) || '';
/**
 * A custom type with cherry-picked properties from the `ProductJSON` type
 * @typedef {Pick<import('../../product-json').ProductJSON, 'tags'> } Product
 */

/**
 * Returns a custom error message
 *
 * The requirement is to map the Shopify API error messages to
 * more user-friendly custom UI error messages.
 * @see https://help.shopify.com/en/themes/development/getting-started/using-ajax-api#error-responses
 * @see https://app.gitbook.com/@decathlonusa/s/shopify/implemented-features-documentation/product-page#inventory-edge-cases
 *
 * @param {string} shopifyErrorMessage
 * @param {Product} product Some error messages need extra product data
 * @returns {string}
 */

const getCustomErrorMessage = (shopifyErrorMessage, product) => {
  // Inventory Case 1: Entirely Sold Out
  if (isErrorScenario1(shopifyErrorMessage)) {
    // Sold out
    if (isNonFollowedProduct(product)) {
      return PRODUCT_PAGE_COPY.INVENTORY_RECENTLY_CHANGED;
    } // Out of stock


    return PRODUCT_PAGE_COPY.OUT_OF_STOCK_RECENTLY_CHANGED;
  } // Inventory Case 2: Not sold out, can add at least 1 to cart


  if (isErrorScenario2(shopifyErrorMessage)) {
    return PRODUCT_PAGE_COPY.allInStockProductsInYourCart(getQuantityFromMessage(shopifyErrorMessage));
  } // Inventory Case 3: Not sold out, all stock already in cart


  if (isErrorScenario3(shopifyErrorMessage)) {
    return PRODUCT_PAGE_COPY.ALL_AVAILABLE_PRODUCTS_IN_CART;
  } // Inventory Case 4: Unknown error message - "Catch All" case
  // return shopifyErrorMessage;
  //nouveau message d'erreur car sinon shopify affiche la totale inventory quantity disponible pour un variant dans son erreur
  //ce qui crée de la confusion


  var messageErreur = translate("Error");

  console.log(messageErreur);
  return messageErreur;
};

export { isNewReleaseProduct as a, isInnovationProduct as b, isNonFollowedProduct as c, isErrorScenario1 as d, isErrorScenario2 as e, getQuantityFromMessage as f, getCustomErrorMessage as g, isErrorScenario3 as h, isBulkyProduct as i, variantHasSufficientQuantity as v };
